/**
 * The Help dialog's body (part 11b, tables M and V): the tester guide from the catalogue, each block an element and each
 * inline mark an element of its own, never HTML text (decision 44). Showing it records the guide's version (V12).
 */
import { guideBlocks, inline, shownVersion } from '../help/guide.ts';
import type { GuideBlock } from '../help/guide.ts';
import { el } from '../ui/dom.ts';
import type { Child } from '../ui/dom.ts';
import type { Shell } from './shell.ts';

/** The element for each mark (M2). */
const TAGS = Object.freeze({ code: 'code', strong: 'strong', em: 'em' });

/** A guide message's runs as text and elements (M2). */
function runs(text: string): Child {
  return inline(text).map((run) => (run.kind === 'text' ? run.text : el(TAGS[run.kind], {}, run.text)));
}

/** One block of the guide (M1); its sections are headings below the dialog's own. */
function block(each: GuideBlock<string>): Child {
  switch (each.kind) {
    case 'heading':
      return el('h3', {}, runs(each.text));
    case 'paragraph':
      return el('p', {}, runs(each.text));
    case 'list':
      return el('ul', {}, each.items.map((item) => el('li', {}, runs(item))));
    case 'table':
      return el(
        'table',
        {},
        el('thead', {}, el('tr', {}, each.head.map((cell) => el('th', { scope: 'col' }, runs(cell))))),
        el('tbody', {}, each.rows.map((cells) => el('tr', {}, cells.map((cell) => el('td', {}, runs(cell)))))),
      );
  }
}

/** The guide, in the interface's language; showing it sets the device's `helpSeen` to its version (V1, V12). */
export function HelpView(shell: Shell): Child {
  const version = shownVersion(shell.t);
  if (shell.workspace.settings().helpSeen !== version) void shell.workspace.updateSettings({ helpSeen: version });
  return el('div', { class: 'help' }, guideBlocks(shell.t).map(block));
}
